<template>
    <div class="flex_start" style="align-items: start">
        <!-- <div class="flex_start" style="justify-content: flex-start"> -->
        <i class="el-icon-warning mr-4" style="width: 14px; height: 14px; color: #ff6f20; margin-top: 1.5px"></i>
        <!-- </div> -->
        <div style="text-align: left">
            <div class="tip-title">温馨提示</div>
            <div class="tip-content mt-8">{{ content }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: { content: { type: String, default: '' } },
    }
</script>
<style lang="scss" scoped>
    .tip-title {
        width: 56px;
        height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #5d6d86;
    }
    .tip-content {
        font-weight: 400;
        font-size: 12px;
        color: #8592a6;
        line-height: 16px;
    }
</style>
